module.exports = __webpack_public_path__ + "static/img/leiniao_verify_success_icon.f55dfe52.png";